import { createContext } from 'react'

export default createContext({
  signatories: [],
  moveSignatory: () => {},
  removeSignatory: () => {}
})
